import React from 'react';
import { GAME_CONFIG } from '../../constants';
import './HomeScreen.css';

const HomeScreen = ({ startGame, questionCount = 0 }) => (
  <div className="screen home-screen">
    <div className="game-background">
      <div className="home-container">
        <div className="title-section">
          <img 
            src="/images/title.png" 
            alt="EDB Landt Quiz" 
            className="game-title-image"
          />
        </div>
        
        <div className="intro-frame">
          <div className="game-intro-content">
            <div className="game-description">
              <div className="info-item info-title">
                玩法/ Introduction
              </div>
              <img src="/images/Line.png" alt="Divider line" className='divider-line'/>
              <div className="game-subtitle">
                挑戰題共有<b>{questionCount}題</b>，每題的作答時間為<b>{GAME_CONFIG.QUESTION_TIMER_SECONDS}秒</b>。如未能在規定時間內作答，則視為答錯。<br/><br/>
                There are <b>{questionCount} questions</b> in total. Each question must be answered within <b>{GAME_CONFIG.QUESTION_TIMER_SECONDS} seconds</b>. If time runs out, the answer will be marked incorrect.
              </div>
            </div>
          </div>
        </div>

        <div className="start-button-container">
          <button className="start-game-btn" onClick={startGame}>
            開始<br/>Start
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default HomeScreen; 